export default class TaskTypes {
  static CUSTOM = "custom";

  static TRANSACTIONS = "transactions";

  static AUDIT = "audit";

  static DOCUMENTS = "documents";

  static BANK_FEEDS = "bankFeeds";
}
